import React from 'react';
import { Link } from 'react-router-dom';
import { mockSatellites } from '../services/dataService';
import { getSatelliteImage } from '../utils/imageUtils';

/**
 * Satellite List Page Component
 */
const SatelliteList = () => {
  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        🛰️ Satellites
      </h1>
      <div className="grid">
        {mockSatellites.map(satellite => (
          <div key={satellite.id} className="card">
            <img 
              src={getSatelliteImage(satellite.id, satellite.name)} 
              alt={satellite.name}
              style={{ 
                width: '100%', 
                height: '200px', 
                objectFit: 'cover', 
                borderRadius: '8px', 
                marginBottom: '15px' 
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {satellite.name}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Orbit Type:</strong> {satellite.orbitType}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Purpose:</strong> {satellite.purpose}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Launch Date:</strong> {satellite.launchDate}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Status:</strong> {satellite.status}
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Expected Lifespan:</strong> {satellite.expectedLifespan}
            </p>
            <Link to={`/satellites/${satellite.id}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SatelliteList;
